import React, {FC} from 'react';

import {Handler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {CrmPreviewPanelId} from '../../store/panels/panelStateBase';
import {CrmPreviewContainer} from '../accounts/crmPreview/crmPreviewContainer';
import {Frame} from '../common/frames/frame';

/*
 * Props.
 */

interface PopupCrmPreviewProps {
  panelId: CrmPreviewPanelId;
  onRequestClose: Handler;
  crmSyncId: number;
}

/*
 * Component.
 */

export const PopupCrmPreview: FC<PopupCrmPreviewProps> = (props) => {
  const {panelId, crmSyncId, onRequestClose} = props;

  return (
    <Frame
      minWidth="550px"
      width={550}
      height={700}
      shouldForcePopout
      onRequestClose={onRequestClose}
      startHeight={undefined}
      interactionId="popup-account-details"
    >
      <CrmPreviewContainer panelId={panelId} crmSyncId={crmSyncId} />
    </Frame>
  );
};
